import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import { Project, Collection, Entry } from '@/types';
import { db } from '@/plugins/firebase';
import { bindFirebaseRef, unbindFirebaseRef } from '@/plugins/bindFirebaseRef';
import { httpsImportIiifManifest } from '@/plugins/firebase-functions';

@Module({ namespaced: true, name: 'admin' })
export default class Admin extends VuexModule {
	public project: Project = {
		id: '',
		title: '',
		description: '',
		likes: {},
		createdAt: 0,
		members: [],
		markdown: ''
	};
	public collections: Collection[] = [];
	public entries: Entry[] = [];

	@Mutation
	SET_ENTRIES(entries: Entry[]) {
		this.entries = entries;
	}

	@Action
	public updateProject() {
		const ref = db.collection('projects').doc(this.project.id);
		ref.update(this.project);
	}

	@Action
	public bindProject(id: string): Promise<any> {
		const ref = db.collection('projects').doc(id);
		return bindFirebaseRef(this.context, 'project', ref);
	}

	@Action
	public bindCollections(projectId: string) {
		const ref = db.collection('collections').where('projectId', '==', projectId);
		return bindFirebaseRef(this.context, 'collections', ref);
	}

	@Action
	public bindEntries(collectionId: string) {
		const ref = db
			.collection('entries')
			.where('projectId', '==', this.project.id)
			.where('collectionId', '==', collectionId);
		bindFirebaseRef(this.context, 'entries', ref);
	}

	@Action({ commit: 'SET_ENTRIES' })
	public unbindEntries() {
		unbindFirebaseRef(this.context, 'entries');
		return [];
	}

	@Action
	public removeEntry(payload: { entryId: string }) {
		return db.collection('entries').doc(payload.entryId).delete();
	}

	@Action
	public addCollection(collection: Collection) {
		collection.projectId = this.project.id;
		return db.collection('collections').add(collection);
	}

	@Action
	public updateCollection(payload: { id: string; collection: Collection }) {
		const ref = db.collection('collections').doc(payload.id);
		return ref.update(payload.collection);
	}

	@Action
	public importManifest(payload: { projectId: string; collectionId: string; manifestUrl: string }) {
		return httpsImportIiifManifest(payload);
	}
}
